import  { useEffect, useState } from "react";
import {
  CircularAvatar,
  ErrorSuccessModal,
  Loader,
  ToggleSwitch,
} from "../../../components/commons";
import { RootState } from "../../../redux/rootReducers";
import { connect } from "react-redux";
import { Label } from "reactstrap";
import DatePicker from "react-datepicker";
import moment from "moment";
import { CalenderIcon } from "../../../components/Icon";
import Select from "react-select";
import { components } from "react-select";

import { formatDate, handleDate } from "../../../utils/commonFunctions";
import { auditSessionFinancialDropdown } from "../../../constant/tableHeadersConstants/fixedAssetConstant/auditSession";
import { getAllFinacUsersAction, resetSession } from "../../../redux/auth";
import { GetAllFinacUserPayloadType } from "../../../commonTypes/authTypes";
import useDebounce from "../../../customHooks/useDebounce";
import {
  createAuditSessionAction,
  updateAuditSessionAction,
} from "../../../redux/fixedAsset/actions";
import {
  resetFixedAssetRegisterError,
  resetFixedAssetRegisterMessage,
  resetFixedAssetRegisterSuccess,
} from "../../../redux/fixedAsset";
import { useLocation } from "react-router-dom";
import {
  AddAuditSessionPayloadType,
  UpdateAuditSessionPayloadType,
} from "../../../commonTypes/fixedAssetRegisterTypes";
type UserListType = {
  label: string | null | undefined;
  value: number | null | undefined | string;
};

type AppProps = {
  history: any;
  token: string | null;
  fetching: boolean;
  error: string | null;
  success: number | null;
  statusCode: number | null;
  message: string | null;
  client_code: number;
  company_name: string;
  finacUsersList: any;
  userFetching: boolean;
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => void;
  dispatchAddAuditSession: (data: AddAuditSessionPayloadType) => void;
  dispatchResetSession: () => void;
  dispatchResetFixedAssetRegisterSuccess: () => void;
  dispatchResetFixedAssetRegisterError: () => void;
  dispatchUpdateAuditSession: (data: UpdateAuditSessionPayloadType) => void;
};
const AddEditAuditForm = ({
  history,
  token,
  fetching,
  error,
  success,
  statusCode,
  message,
  client_code,
  company_name,
  finacUsersList,
  userFetching,
  dispatchGetAllFinacUsersAction,
  dispatchResetFixedAssetRegisterSuccess,
  dispatchResetFixedAssetRegisterError,
  dispatchAddAuditSession,
  dispatchResetSession,
  dispatchUpdateAuditSession,
}: AppProps) => {
  const data =
    history &&
    history.location &&
    history.location.state &&
    history.location.state.data
      ? history.location.state.data
      : "";
  const id =
    history &&
    history.location &&
    history.location.state &&
    history.location.state.audit_session_id
      ? history.location.state.audit_session_id
      : "";

  const { pathname } = useLocation();
  const [offset, setoffset] = useState(0);
  const [loadCondition, setLoadCondition] = useState(true);
  const [text, setText] = useState("");
  const [limit, setLimit] = useState(20);
  const [finalUserList, setFinalUserList] = useState<UserListType[] | []>([]);
  const [userSelected, setUserSelected] = useState<UserListType[] | []>([
    {
      value: null,
      label: "",
    },
  ]);
  const [selectedAccessTeam, setSelectedAccessTeam] = useState<any>([]);
  const [startDateError, setStateDateError] = useState("");
  const [endDateError, setEndDateError] = useState("");
  const [auditData, setAuditData] = useState<any>({
    client: "",
    startDate: "",
    endDate: "",
    auditStatus: true,
  });
  const [financialYear, setFinancialYear] = useState({
    value: "",
    label: "Select..",
  });

  useEffect(() => {
    const finalUserData = finacUsersList?.data?.map((user: any) => {
      return {
        value: user?.user_id,
        label: `${user?.first_name ? user?.first_name : ""} ${
          user?.last_name ? user?.last_name : ""
        }`,
        image: user?.profile_pic?.file_url,
      };
    });
    if (offset > 0) {
      setFinalUserList([...finalUserList, ...finalUserData]);
    } else {
      setFinalUserList(finalUserData);
    }
  }, [finacUsersList]);

  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset,
        limit,
        user_type: "stco_users",
        status: 1,
        client_code,
        search_term: text,
      };
      if (offset <= finacUsersList?.total_count) {
        dispatchGetAllFinacUsersAction(finalUserData);
      }
    }
  }, [offset]);

  const fetchNewData = (search: string) => {
    const finalData = {
      token,
      offset,
      limit,
      user_type: "stco_users",
      status: 1,
      client_code,
      search_term: text,
    };
    dispatchGetAllFinacUsersAction(finalData);
  };

  useDebounce(
    () => {
      if (text) {
        fetchNewData(text);
      } else {
        const finalData = {
          token,
          offset,
          limit,
          user_type: "stco_users",
          status: 1,
          search_term: text,
        };
        dispatchGetAllFinacUsersAction(finalData);
      }
    },
    500,
    [text]
  );

  useEffect(() => {
    if (!pathname?.includes("add")) {
      setAuditData((prev: any) => ({
        client: data?.client_code,
        startDate: data?.start_date ? formatDate(data?.start_date) : "",
        endDate: data?.end_date ? formatDate(data?.end_date) : "",
        auditStatus: data?.status,
      }));
      if (data?.user_details) {
        let totalUser = data?.user_details?.map((e: any) => {
          return {
            value: e?.user_id,
            label: `${e?.first_name}${e?.last_name}`,
          };
        });
        const auditTeamId = data?.user_details?.map((e: any) => e?.user_id);
        setUserSelected(totalUser);
        setSelectedAccessTeam(auditTeamId);
      }
      setFinancialYear({
        value: data?.financial_year,
        label: data?.financial_year,
      });
    } else {
      setAuditData((prev: any) => {
        return {
          client: "",
          startDate: "",
          endDate: "",
        };
      });
      setFinancialYear({
        value: "",
        label: "Select..",
      });
    }
  }, [data]);

  const handleUserChange = (e: any) => {
    let accessTeamIdName: any = e?.map((e: any) => {
      return e?.value;
    });

    let totaleUser = e?.map((e: any) => {
      return {
        value: e?.value,
        label: e?.label,
      };
    });
    setUserSelected(totaleUser);
    setSelectedAccessTeam(accessTeamIdName);
  };
  const handleFinancialChange = (data: any) => {
    setFinancialYear({
      value: data?.value,
      label: data?.label,
    });
  };
  const onMenuClose = () => {
    setLoadCondition(true);
  };

  const checkBottom = (e: any) => {
    setLoadCondition(false);
    setoffset((prv: any) => prv + limit);
  };
  const handleChange = (date: any) => {
    const value = handleDate(date);
    setAuditData({
      ...auditData,
      startDate: value,
    });
  };
  const handleEndDateChange = (date: any) => {
    const value = handleDate(date);
    setAuditData({
      ...auditData,
      endDate: value,
    });
  };
  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          <CircularAvatar
            name={data?.label}
            image={data?.image && data?.image}
          />
          {data?.label}
        </div>
      </components.Option>
    );
  };
  const handleToogleStatusChange = () => {
    if (pathname.includes("add")) {
      setAuditData({
        ...auditData,
        auditStatus: true,
      });
    } else {
      setAuditData({
        ...auditData,
        auditStatus: !auditData.auditStatus,
      });
    }
  };
  const handleSubmit = () => {
    let finalData = {
      token,
      client_code,
      start_date: auditData?.startDate,
      end_date: auditData?.endDate,
      financial_year: financialYear?.value,
      audit_team: selectedAccessTeam,
    };
    if (pathname?.includes("add")) {
      dispatchAddAuditSession(finalData);
    }
    if (pathname?.includes("edit")) {
      let finalEditData = {
        token,
        client_code,
        audit_session_id: id,
        start_date: auditData?.startDate,
        end_date: auditData?.endDate,
        audit_team: selectedAccessTeam,
        status: auditData?.auditStatus ? 1 : 0,
      };
      dispatchUpdateAuditSession(finalEditData);
    }
  };
  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetFixedAssetRegisterError();
            }}
          />
        );
      }
    }
    if (
      (success === 1 &&
        message === "Audit session has been added successfully!") ||
      message === "Audit session has been updated successfully!"
    ) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message={message}
          buttonText="OK"
          onPress={() => {
            dispatchResetFixedAssetRegisterSuccess();
            dispatchResetFixedAssetRegisterError();
            history?.push({
              pathname: `/fixed-asset-register/audit-session/${client_code}`,
              state: { client_code, company_name },
            });
          }}
        />
      );
    }
  };
  return (
    <>
      <div className="row">
        <div className="col-md-3">
          <div className="form-group">
            <label htmlFor="clientName">
              Client Code <span className="color-red">*</span>
            </label>
            <div>
              <input
                name="title"
                type="text"
                className={`form-control`}
                disabled
                value={`${company_name}(${client_code})`}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-3 form-group mt-3">
          <label>
            Start Date <span className="color-red">*</span>
          </label>
          <div className="d-flex flex-row position-relative mt-1">
            <div className="date-picker-wraper mr-0 w-100">
              <Label className="m-0 p-0 w-100">
                <DatePicker
                  dateFormat="dd-MM-yyyy"
                  selected={
                    auditData?.startDate
                      ? new Date(
                          moment(
                            `${auditData?.startDate}T00:00:00`,
                            "DD-MM-YYYY"
                          ).format("YYYY-MM-DD[T]HH:mm:ss")
                        )
                      : null
                  }
                  onChange={(e: any) =>
                    handleChange(e ? moment(e).format("DD-MM-YYYY") : null)
                  }
                  fixedHeight
                  showMonthDropdown
                  showYearDropdown
                  name="startDate"
                  placeholderText="Choose Date"
                  className="form-control pointer"
                />
                <span
                  className="calender-icon"
                  style={{ right: "25px", cursor: "pointer" }}
                >
                  <CalenderIcon />
                </span>
              </Label>
            </div>
          </div>

          <div>
            {!!startDateError && (
              <small className="text-danger">{startDateError}</small>
            )}
          </div>
        </div>
        <div
          className="col-md-3 form-group mt-3"
          style={{ marginLeft: "11px" }}
        >
          <label>
            End Date <span className="color-red">*</span>
          </label>
          <div className="d-flex flex-row position-relative mt-1">
            <div className="date-picker-wraper mr-0 w-100">
              <Label className="m-0 p-0 w-100">
                <DatePicker
                  dateFormat="dd-MM-yyyy"
                  selected={
                    auditData?.endDate
                      ? new Date(
                          moment(
                            `${auditData?.endDate}T00:00:00`,
                            "DD-MM-YYYY"
                          ).format("YYYY-MM-DD[T]HH:mm:ss")
                        )
                      : null
                  }
                  onChange={(e: any) =>
                    handleEndDateChange(
                      e ? moment(e).format("DD-MM-YYYY") : null
                    )
                  }
                  fixedHeight
                  showMonthDropdown
                  showYearDropdown
                  name="endDate"
                  placeholderText="Choose Date"
                  className="form-control pointer"
                  minDate={
                    auditData?.startDate
                      ? new Date(
                          moment(
                            `${auditData?.startDate}T00:00:00`,
                            "DD-MM-YYYY"
                          ).format("YYYY-MM-DD[T]HH:mm:ss")
                        )
                      : null
                  }
                  disabled={!auditData?.startDate}
                />
                <span
                  className="calender-icon"
                  style={{ right: "25px", cursor: "pointer" }}
                >
                  <CalenderIcon />
                </span>
              </Label>
            </div>
          </div>

          <div>
            {!!endDateError && (
              <small className="text-danger">{endDateError}</small>
            )}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-3 mt-3">
          <label className="mb-1" htmlFor="">
            Financial Year <span className="color-red">*</span>
          </label>
          <Select
            options={auditSessionFinancialDropdown}
            value={financialYear}
            onChange={handleFinancialChange}
            isDisabled={pathname?.includes("edit")}
          />
        </div>
        <div className="col-md-3 mt-3" style={{ marginLeft: "10px" }}>
          <form>
            <div className="form-group">
              <label className="mb-1">Audit Team</label>
              <Select
                className="dropdown"
                placeholder="Select..."
                value={userSelected[0]?.label ? userSelected : []}
                options={finalUserList}
                onChange={handleUserChange}
                isMulti
                isClearable
                components={{ Option }}
                isLoading={userFetching}
                onMenuClose={onMenuClose}
                isSearchable={true}
                onMenuScrollToBottom={(e: any) => checkBottom(e)}
                onInputChange={(e: string) => {
                  setLoadCondition(false);
                  setText(e);
                  setoffset(0);
                }}
              />
            </div>
          </form>
        </div>
      </div>
      <div className="row">
        <div className="col-md-4 form-group mt-3">
          <label htmlFor="Job Status" className="mb-2">
            Status
          </label>
          <ToggleSwitch
            handleToggleChange={() => handleToogleStatusChange()}
            isChecked={auditData?.auditStatus}
          />
        </div>
      </div>
      <div className="">
        <div style={{ marginTop: "2rem" }}>
          <hr></hr>
        </div>

        <div className="row mt-3">
          <div className="col-md-12 d-flex justify-content-end ">
            <button
              className="btn ml-3"
              style={{ border: "1px solid #bfcbe1" }}
              onClick={() => {
                history.goBack();
              }}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary ml-3 pr-4 pl-4"
              onClick={handleSubmit}
              disabled={
                !auditData?.startDate ||
                !auditData?.endDate ||
                !financialYear?.value
              }
            >
              {pathname?.includes("add") ? "Save" : "Save Changes"}
            </button>
          </div>
        </div>
      </div>
      {fetching && <Loader />}
      {handleErrorModal()}
    </>
  );
};
const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.fixedAssetRegister.fetching,
  success: state.fixedAssetRegister.success,
  message: state.fixedAssetRegister.message,
  statusCode: state.fixedAssetRegister.statusCode,
  error: state.fixedAssetRegister.error,
  userFetching: state.auth.fetching,
  finacUsersList: state.auth.finacUsersList,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacUsersAction(data)),
  dispatchAddAuditSession: (data: AddAuditSessionPayloadType) =>
    dispatch(createAuditSessionAction(data)),
  dispatchUpdateAuditSession: (data: UpdateAuditSessionPayloadType) =>
    dispatch(updateAuditSessionAction(data)),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetFixedAssetRegisterSuccess: () =>
    dispatch(resetFixedAssetRegisterSuccess()),
  dispatchResetFixedAssetRegisterError: () =>
    dispatch(resetFixedAssetRegisterError()),
});
export default connect(mapStateToProps, mapDispatchToProps)(AddEditAuditForm);
